import {
  geoPath as d3GeoPath,
  GeoPath,
  GeoProjection,
  GeoIdentityTransform,
} from 'd3-geo';
import { h } from 'preact';

import PureComponent from './PureComponent';
import PureCanvas from './PureCanvas';

export interface CanvasLayerProps {
  projection: GeoProjection | GeoIdentityTransform;
  width: number;
  height: number;
  render: (
    ctx: CanvasRenderingContext2D,
    geoPath: GeoPath,
    pixelRatio: number
  ) => void;
}

class CanvasLayer extends PureComponent<CanvasLayerProps> {
  ctx!: CanvasRenderingContext2D;
  canvas!: HTMLCanvasElement;
  geoPath!: GeoPath;
  pixelRatio!: number;

  constructor() {
    super();

    this.setContextRef = this.setContextRef.bind(this);
  }

  setContextRef(ctx: CanvasRenderingContext2D, canvas: HTMLCanvasElement) {
    this.ctx = ctx;
    this.canvas = canvas;
  }

  draw() {
    const ctx = this.ctx;
    const geoPath = this.geoPath;
    const pixelRatio = this.pixelRatio;
    const { render } = this.props;

    render(ctx, geoPath, pixelRatio);
  }

  scaleCanvas(
    canvas: HTMLCanvasElement,
    ctx: CanvasRenderingContext2D,
    width: number,
    height: number
  ) {
    const pixelRatio = window.devicePixelRatio || 1;
    this.pixelRatio = pixelRatio;

    canvas.width = width * pixelRatio;
    canvas.height = height * pixelRatio;

    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    ctx.scale(pixelRatio, pixelRatio);
  }

  updateCanvas() {
    this.scaleCanvas(
      this.canvas,
      this.ctx,
      this.props.width,
      this.props.height
    );
    this.draw();
  }

  componentDidMount() {
    // we cannot set up our geoPath until we have a context
    this.geoPath = d3GeoPath(this.props.projection, this.ctx);

    this.updateCanvas();
  }

  componentDidUpdate() {
    this.updateCanvas();
  }

  render() {
    return (
      <PureCanvas
        style={{ position: 'absolute', top: 0, left: 0, zIndex: 1 }}
        contextRef={this.setContextRef}
      />
    );
  }
}

export default CanvasLayer;
